import React, {useEffect, useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {HttpStatus} from "../../../../modules/common/enums/HttpStatus";
import {MessageUtils} from "../../../../utils/MessageUtils";
import {Card, CardContent, CardHeader, Divider, List, ListItemButton, ListItemText, Stack,} from "@mui/material";
import {DataGroupDto} from "../../../../modules/account/dto/DataGroupDto";
import {DataGroupApi} from "../../../../modules/account/api/DataGroupApi";
import AddIconButton from "../../../../components/buttons/AddIconButton";
import DataGroupDetailDialog from "./components/DataGroupDetailDialog";
import {useConfirm} from "material-ui-confirm";
import RefreshIconButton from "../../../../components/buttons/RefreshIconButton";

export default function Index() {
    const intl = useIntl();

    const confirm = useConfirm();

    const [openDataGroupDetailModal, setopenDataGroupDetailModal] = useState(false);
    const [currentRow, setCurrentRow] = useState<DataGroupDto>(new DataGroupDto());

    const [dataGroups, setDataGroups] = useState<Array<DataGroupDto>>([]);

    // key: id, value: DataGroupDto
    const [dataGroupMap, setDataGroupMap] = useState(new Map<string, DataGroupDto>());

    useEffect(() => {
        _fetchDataGroups();
    }, []);

    const _fetchDataGroups = async () => {
        const responseResult = await DataGroupApi.getDataGroupList();
        if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
            // 构建数据组的Map
            const dataGroupMap = new Map<string, DataGroupDto>();
            for (let item of responseResult.data) {
                dataGroupMap.set(item.id, item);
            }
            setDataGroupMap(dataGroupMap);
            setDataGroups(DataGroupApi.constructDataGroupTree(responseResult.data));
        }
    };

    const _handleClickRefresh = async () => {
        _fetchDataGroups();
    };

    const _handleClickAdd = () => {
        const dataGroup = new DataGroupDto();
        setCurrentRow(dataGroup);
        setopenDataGroupDetailModal(true);
    }

    const _handleClickModify = async (record: DataGroupDto) => {
        const responseResult = await DataGroupApi.getDataGroupDetail(record.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setCurrentRow(responseResult.data);
            setopenDataGroupDetailModal(true);
        }
    }

    const _handleClickDelete = async (record: DataGroupDto) => {
        confirm({title: intl.formatMessage({id: 'COMMON_DELETE_CONFIRM'})})
            .then(async () => {
                const responseResult = await DataGroupApi.deleteDataGroup(record.id);
                if (responseResult.status === HttpStatus.SUCCESS) {
                    MessageUtils.success(intl.formatMessage({id: 'COMMON_DELETE_SUCCESS'}));
                    _fetchDataGroups();
                }
            })
            .catch(() => {
                console.log('cancel');
            });
    };

    const _renderChildren = (children: Array<DataGroupDto>, level: number) => {
        return (
            <List component="div" disablePadding>
                {
                    children.map((child, index) => {
                        return (
                            <div>
                                <ListItemButton key={child.id} sx={{pl: 4 * level}}>
                                    <ListItemText primary={child.name} secondary={child.code}/>
                                    <Stack direction={'row'} spacing={1}>
                                        <a href={'javascript:void(0)'} onClick={() => _handleClickModify(child)}>
                                            <FormattedMessage id={'COMMON_MODIFY'}/>
                                        </a>
                                        <a href={'javascript:void(0)'} onClick={() => _handleClickDelete(child)}>
                                            <FormattedMessage id={'COMMON_DELETE'}/>
                                        </a>
                                    </Stack>
                                </ListItemButton>
                                {child.children ? _renderChildren(child.children, level + 1) : null}
                            </div>
                        )
                    })
                }
            </List>
        )
    }

    return (
        <div>
            <DataGroupDetailDialog open={openDataGroupDetailModal} dataGroup={currentRow} dataGroups={dataGroups}
                                   dataGroupMap={dataGroupMap}
                                   onClose={() => setopenDataGroupDetailModal(false)}
                                   onOk={() => _fetchDataGroups()}/>
            <Card>
                <CardHeader
                    title={intl.formatMessage({id: 'ACCOUNT_DATA_GROUP_MANAGEMENT'})}
                    action={
                        <div>
                            <AddIconButton onClick={_handleClickAdd}/>
                            <RefreshIconButton onClick={_handleClickRefresh}/>
                        </div>
                    }
                />
                <CardContent>
                    <List>
                        {
                            dataGroups.map((item, index) => {
                                return (
                                    <div key={item.id}>
                                        <ListItemButton>
                                            <ListItemText primary={item.name} secondary={item.code}/>
                                            <Stack direction={'row'} spacing={1}>
                                                <a href={'javascript:void(0)'} onClick={() => _handleClickModify(item)}>
                                                    <FormattedMessage id={'COMMON_MODIFY'}/>
                                                </a>
                                                <a href={'javascript:void(0)'} onClick={() => _handleClickDelete(item)}>
                                                    <FormattedMessage id={'COMMON_DELETE'}/>
                                                </a>
                                            </Stack>
                                        </ListItemButton>
                                        {item.children ? _renderChildren(item.children, 1) : null}
                                        <Divider sx={{mt: 2, mb: 2}}/>
                                    </div>
                                )
                            })
                        }
                    </List>
                </CardContent>
            </Card>
        </div>
    );
}